// FIXME: we have circular dependency here, you must kill export default and imports below 😈
import { store } from 'store/configureStore';
import * as authSelectors from 'modules/auth/selectors';

import { deprecated } from './';

/**
 * @param {string[]} userPermissions
 * @param {string[]} givenPermissions
 */
export const checkPermissions = (userPermissions, givenPermissions) => {
  deprecated('checkPermissions/2', 'cs.authHasPermission');

  if (!userPermissions) {
    return false;
  }

  const givenPermissionsArray = [].concat(givenPermissions);

  if (!givenPermissions || !givenPermissionsArray.length) {
    return true;
  }

  for (let i = givenPermissionsArray.length - 1; i >= 0; i--) {
    if (userPermissions.indexOf(givenPermissionsArray[i]) !== -1) {
      return true;
    }
  }

  return false;
};

export default (userPermissions, givenPermissions) => {
  if (givenPermissions === undefined) {
    deprecated('checkPermissions/1', 'cs.authHasPermission');

    return checkPermissions(authSelectors.permissions(store.getState()), userPermissions);
  }

  return checkPermissions(userPermissions, givenPermissions);
};



// WEBPACK FOOTER //
// ./src/common/utils/checkPermissions.js